import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { User } from '@/models/User';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

interface AuthObject {
    email: string;
    password: string;
}

interface UserData {
    '@id': string;
    'id': number;
    'firstName': string;
    'lastName': string;
    'email': string;
    'address': string;
    'phoneNumber': string;
    'forms': string[];
    'organisations': string[];
    'isMe': boolean;
    'isOwner': boolean;
}

@Module({ namespaced: true })
class AccountModule extends VuexModule {
    _account!: User;

    get account(): User {
        return this._account;
    }

    get token() {
        return localStorage.getItem('rbb:token');
    }

    @Mutation
    set(user: User) {
        this._account = user;
    }

    @Action
    async auth() {
        return await axios({ method: 'GET', url: '/api/me' });
    }

    @Action
    async init(): Promise<User | boolean> {
        try {
            const r: any = await axios({
                method: 'GET',
                url: '/api/me',
            });

            if (r.response && r.response.status === 401) {
                return false;
            }

            const account = new User(r.data);

            this.context.commit('set', account);
            return account;
        } catch (e) {
            return false;
        }
    }

    @Action
    logout() {
        return localStorage.removeItem('rbb:token');
    }

    @Action
    async login({ email, password }: AuthObject) {
        return await axios({
            method: 'POST',
            url: '/api/token',
            data: { email, password },
        });
    }

    @Action
    async requestToken(email: string) {
        return axios({
            method: 'POST',
            url: `/api/reset-password`,
            data: { email },
        });
    }

    @Action
    async resetPassword(token: string, plainPassword: string) {
        return axios({
            method: 'POST',
            url: `/api/reset-password/reset/${token}`,
            data: { plainPassword },
        });
    }
}

export default AccountModule;
